import React from 'react';

const NebulaBrainHistoryFormModal = React.lazy(() => import('../components/FormModal'));
const nebulaBrainHistoryModalRegistry = {
    personalize_nebulaBrainHistoryId: NebulaBrainHistoryFormModal
};
export default nebulaBrainHistoryModalRegistry;
